'use client'

import { useEffect, useState } from 'react'
import { useIsMobile } from '@/hooks/use-mobile'
import Pricing from '@/components/home/Pricing'
import Footer from '@/components/home/Footer'
import posthog from 'posthog-js'
import { createClientComponentClient } from "@supabase/auth-helpers-nextjs"
import UserAuthDisplay from '@/components/ui/userAuthDisplay'

// Query params are read from window.location after hydration instead of
// useSearchParams: useSearchParams forces the whole page behind a Suspense
// boundary during static prerender, so crawlers saw only the fallback
// (no h1, no content). The skool/legacy variants are client-side
// personalizations and can apply post-hydration.
export default function PricingPage() {
  const isMobile = useIsMobile()
  const [isFromSkool, setIsFromSkool] = useState(false)
  const [isLegacyPricing, setIsLegacyPricing] = useState(false)
  const [paramsRead, setParamsRead] = useState(false)
  const [userEmail, setUserEmail] = useState<string | null>(null)
  const supabase = createClientComponentClient()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    setIsFromSkool(params.get('from') === 'skool')
    setIsLegacyPricing(params.get('legacy') === 'true')
    setParamsRead(true)
  }, [])

  useEffect(() => {
    // Fetch user session to get email
    const fetchSession = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession()
        if (session?.user?.email) {
          setUserEmail(session.user.email)
        }
      } catch (err) {
        console.error('Error fetching session:', err)
      }
    }

    fetchSession()
  }, [supabase])

  useEffect(() => {
    if (!paramsRead) return
    if (posthog?.__loaded) {
      const properties: any = {
        path: window.location.pathname,
        referrer: document.referrer,
        is_from_skool: isFromSkool,
        is_legacy_pricing: isLegacyPricing,
        $set: {
          last_page_view: 'pricing'
        }
      }

      // Add email to $set properties if available
      if (userEmail) {
        properties.$set = {
          ...properties.$set,
          email: userEmail
        }
      }

      posthog.capture('v2_page_view_pricing', properties);
    }
  }, [paramsRead, isFromSkool, isLegacyPricing, userEmail]);

  return (
    <>
      <UserAuthDisplay />
      <Pricing isMobile={isMobile} isFromSkool={isFromSkool} isLegacyPricing={isLegacyPricing} headingAs="h1" />
      {/* <Footer isMobile={isMobile} /> */}
    </>
  )
}
